import { postEvent } from '../api/tracking';
import { AnalyticsOptions } from './AnalyticsOptions';
import { AnalyticsHandler } from './IAnalyticsHandler';

export class BIEventsOptions extends AnalyticsOptions {
  userID: string;

  constructor(values: any[], userID: string) {
    super(values);
    this.userID = userID;
  }
}

export class BIEventsAnalyticsHandler extends AnalyticsHandler {
  constructor() {
    super();
    this.initialize();
  }

  protected initialize(): void {
    /* Nothing relevant for its initialization */
  }

  public log(
    logEvent: string,
    options: { values: any[]; userID: string },
  ): void {
    const biEventsOptions = new BIEventsOptions(options.values, options.userID);
    postEvent(logEvent, options.userID, { ...biEventsOptions.values });
  }
}
